export enum AdditionalProfilePath {
  Profile = 'profile/:profileCode',
  NewProfile = 'profile',
}
